<div *ngIf="connection" class="company-connectivity-overview">
  <table class="company-connectivity-overview__table">
    <tbody>
      <tr>
        <td class="label" translate>company.connectivity.details.overview.table.provider.label</td>
        <td>{{connection.provider_name}}</td>
        <td></td>
      </tr>
      <tr>
        <td class="label" translate>company.connectivity.details.overview.table.type.label</td>
        <td>
          <gdp-connection-type [type]="connection.type"></gdp-connection-type>
        </td>
        <td></td>
      </tr>
      <tr>
        <td class="label" translate>company.connectivity.details.overview.table.locked.label</td>
        <td>{{connection.is_locked}}</td>
        <td></td>
      </tr>
      <tr>
        <td class="label" translate>company.connectivity.details.overview.table.contacts.label</td>
        <td>
          <ul *ngIf="connection.contacts.length !== 0" class="data-list">
            <li *ngFor="let c of connection.contacts">
              <span>{{c.first_name}} {{c.last_name}}
                <a href="mailto:{{c.email}}">{{c.email}}</a>
                <span *ngFor="let phone of c.phone_numbers"> {{phone}}</span>
              </span>
            </li>
          </ul>
          <span *ngIf="connection.contacts.length === 0"> - </span>
        </td>
        <td></td>
      </tr>
      <tr>
        <td class="label" translate>company.connectivity.details.overview.table.reseller.label</td>
        <td>
          <div class="data">
            <span><b translate>company.connectivity.details.overview.table.reseller.data.id</b></span>
            <span *ngIf="connection.reseller_payment?.reseller_id">{{connection.reseller_payment.reseller_id}}</span>
            <span *ngIf="!connection.reseller_payment?.reseller_id"> - </span>
          </div>
          <div class="data">
            <span><b translate>company.connectivity.details.overview.table.reseller.data.status</b></span>
            <span *ngIf="connection.reseller_payment?.reseller_payment_status">
              <gdp-reseller-payment-status [status]="connection.reseller_payment.reseller_payment_status">
              </gdp-reseller-payment-status>
            </span>
            <span *ngIf="!connection.reseller_payment?.reseller_payment_status"> - </span>
          </div>
        </td>
        <td></td>
      </tr>
      <tr *ngIf="!loading.status">
        <td class="label" translate>company.connectivity.details.overview.table.status.label</td>
        <td>
          <div class="data">
            <span><b translate>company.connectivity.details.overview.table.status.data.ip</b></span>
            <span *ngIf="connectionStatus?.ip_address">{{connectionStatus.ip_address}}</span>
            <span *ngIf="!connectionStatus?.ip_address"> - </span>
          </div>
          <div class="data">
            <span><b translate>company.connectivity.details.overview.table.status.data.ping</b></span>
            <span>
              {{connectionStatus?.successful_pings.toString() || '-' }}/{{connectionStatus?.total_pings.toString() ||
              '-'}}
            </span>
          </div>
          <div class="data">
            <span><b translate>company.connectivity.details.overview.table.status.data.timestamp</b></span>
            <span *ngIf="connectionStatus?.date">{{connectionStatus.date | date: 'medium'}}</span>
            <span *ngIf="!connectionStatus?.date"> - </span>
          </div>
        </td>
        <td>
          <button class="vox-btn vox-btn-secondary" [disabled]="company && company.readOnly" (click)="refreshStatus()"
            translate>company.connectivity.details.overview.table.status.action</button>
        </td>
      </tr>
      <tr *ngIf="loading.status">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{
            'height':'40px',
            'width': 'calc(100% - 12px)',
            'margin-top': '15px',
            'margin-bottom': '15px',
            'margin-left': '10px',
            'margin-right': '10px'
          }"></ngx-skeleton-loader>
        </td>
      </tr>
      <tr *ngIf="!loading.ping">
        <td class="label" translate>company.connectivity.details.overview.table.ping.label</td>
        <td>
          <div class="data">
            <span><b translate>company.connectivity.details.overview.table.ping.data.status</b></span>
            <span *ngIf="[true, false].includes(connectionPing?.ping_status)">{{connectionPing.ping_status |
              json}}</span>
            <span *ngIf="![true, false].includes(connectionPing?.ping_status)"> - </span>
          </div>
          <div class="data">
            <span><b translate>company.connectivity.details.overview.table.ping.data.description</b></span>
            <span *ngIf="!connectionPing?.ping_description"> - </span>
            <div>
              <code class="data-description" *ngIf="connectionPing?.ping_description"
                [innerHTML]="connectionPing.ping_description"></code>
            </div>
          </div>
        </td>
        <td>
          <button class="vox-btn vox-btn-secondary" [disabled]="company && company.readOnly" (click)="goPing()"
            translate>company.connectivity.details.overview.table.ping.action</button>
        </td>
      </tr>
      <tr *ngIf="loading.ping">
        <td colspan="3">
          <ngx-skeleton-loader [theme]="{
            'height':'40px',
            'width': 'calc(100% - 12px)',
            'margin-top': '15px',
            'margin-bottom': '15px',
            'margin-left': '10px',
            'margin-right': '10px'
          }"></ngx-skeleton-loader>
        </td>
      </tr>
    </tbody>
  </table>
</div>